import "./assets/main.css";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

const app = createApp( App );
app.component('FontAwesomeIcon', FontAwesomeIcon);   // https://docs.fontawesome.com/web/use-with/vue/add-icons/

// createApp(App).mount("#app");
app.mount( '#app' );

